var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "#FFF",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.999 21v-6.587l2.537 2.537.094.083c.392.305.96.277 1.32-.083.36-.36.388-.928.083-1.32l-.083-.094-3.726-3.727c-.036-.189-.128-.37-.274-.516-.226-.226-.534-.321-.829-.286-.294-.035-.602.06-.828.286-.117.117-.2.256-.246.403l-.029.112-3.725 3.728c-.39.39-.39 1.023 0 1.414.36.36.928.388 1.32.083l.094-.083L17 14.657V21H12c-2.21 0-4-1.79-4-4 0-1.498.824-2.804 2.043-3.49-.028-.164-.043-.335-.043-.51 0-1.657 1.343-3 3-3 .259 0 .51.033.75.094C14.771 8.25 16.74 7 19 7c3.314 0 6 2.686 6 6l-.001.126C26.724 13.569 28 15.136 28 17c0 2.21-1.79 4-4 4h-5v7c0 .552-.448 1-1 1s-1-.448-1-1v-7h1.999z",
    transform: "translate(-283 -1177) translate(81 734) translate(202 443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2b4032863cdaa401d05c4f5cb4e5083c.svg";
export { ForwardRef as ReactComponent };